import React from 'react'
import '../Theme.css';
import './Loader.css';
import Loaders from "react-loader-spinner";

function Loader() {
    return (
        <div className={"LoaderRoot"}>
            <Loaders
                type="Hearts"
                color="#00E0CA"
                height={64}
                width={64}
            />
        </div>

    )
}

export default Loader;
